import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";

class CustomBarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [],
      options: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "45%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },

        colors: ["#34c38f", "#556ee6", "#f46a6a"],
        xaxis: {
          type: "category",
          categories: [],
        },
        yaxis: {
          title: {
            text: this.props.yaxisName,
          },
        },
        grid: {
          borderColor: "#f1f1f1",
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: val => {
              return val;
            },
          },
        },
      },
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      this.updateChart();
    }
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  updateChart = () => {
    const seriesKeys = [];
    const seriesData = {};
    const series = [];

    const _categories = this.props.categories;
    const categories = [];

    this.props.data.map(i => {
      for (let [key, value] of Object.entries(i)) {
        if (seriesKeys.find(o => o === key) === undefined) {
          if (key !== _categories[0]) {
            seriesKeys.push(key);
            seriesData[key] = [];
          }
        }
      }
    });

    this.props.data.map((i, idx) => {
      for (let [key, value] of Object.entries(i)) {
        if (_categories.find(o => o === key)) {
          // categories.hasOwnProperty(key)
          categories.push(value);
        }

        if (seriesKeys.find(o => o === key)) {
          seriesData[key].push({
            x: `${
              typeof value !== "string"
                ? this.capitalizeFirstLetter(_categories[0])
                : ""
            } ${this.props.data[idx][_categories[0]]}`,
            y: value,
          });
        }
      }
    });

    for (let [key, value] of Object.entries(seriesData)) {
      series.push({
        name: key,
        data: value,
      });
    }

    let title = { title: { text: this.props.yaxisName } };
    let options = this.state.options;

    options.xaxis.categories = categories;
    options.yaxis.title = title;

    this.setState({
      series,
      options,
    });
  };

  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={350}
          className="apex-charts"
        />
      </React.Fragment>
    );
  }
}

CustomBarChart.propTypes = {
  onChange: PropTypes.func,
  data: PropTypes.any,
  xValue: PropTypes.string,
  yaxisName: PropTypes.string,
  descriptionName: PropTypes.string,
  categories: PropTypes.array,
};

export default CustomBarChart;
